import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';

export default function(validate, form){
    return {
        title     : 'Your details',
        component : rawDynamicImport(() => import('@app/booking/components/form/stages/contact_details/ContactDetails.vue')),
        isValid   : computed(
            () => validate({
                'forename'                            : ['required'],
                'surname'                             : ['required'],
                'contact.email'                       : ['required', 'email'],
                'contact.email_confirmation'          : ['required', 'email'],
                'contact.contact_number'              : ['required'],
                'contact.contact_number_confirmation' : ['required'],
                'contact.address_line_1'              : ['required'],
                'contact.postcode'                    : ['required'],
                'contact.city'                        : ['required'],
                'contact.county'                      : ['required'],
                'contact.country'                     : ['required'],
            })
        ),
        data: computed(
            () => ({
                forename                        : form.value.forename,
                middle_name                     : form.value.middle_name,
                surname                         : form.value.surname,
                organisation                    : form.value.organisation,
                how_did_you_hear_about_us       : form.value.how_did_you_hear_about_us?.value,
                how_did_you_hear_about_us_other : form.value.how_did_you_hear_about_us_other,
                contact                         : {
                    email                       : form.value.contact?.email,
                    email_confirmation          : form.value.contact?.email_confirmation,
                    contact_number              : form.value.contact?.contact_number,
                    contact_number_confirmation : form.value.contact?.contact_number_confirmation,
                    mobile_number               : form.value.contact?.mobile_number,
                    address_line_1              : form.value.contact?.address_line_1,
                    address_line_2              : form.value.contact?.address_line_2,
                    city                        : form.value.contact?.city,
                    postcode                    : form.value.contact?.postcode,
                    county                      : form.value.contact?.county,
                    country                     : form.value.contact?.country
                }
            })
        ),
    }
}